module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "dw-shop header__back",
    attrs: {
      "href": "https://www.danielwellington.com",
      "title": "Go to the store",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticClass: "header__arrow"
  }, [_c('span', {
    staticClass: "header__icon icon-arrow"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__continue"
  }, [_vm._v(_vm._s(_vm.$t('continue')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "dw-logo router-link-active",
    attrs: {
      "to": _vm.locale,
      "title": "Daniel Wellington"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5930af97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 415
// module chunks = 1